import { GoogleTagManager } from '@next/third-parties/google';
import { publishPlatformMeta } from '@/domains/shared/analytics/platformMeta';
import { getPlatform, isNative } from '@/domains/shared/utils/native';

const getDataLayer = (): object[] | null => {
  if (typeof window === 'undefined') return null;
  window.dataLayer = window.dataLayer || [];
  return window.dataLayer;
};

const pushToDataLayer = (...items: object[]) => {
  getDataLayer()?.push(...items);
};

if (typeof window !== 'undefined') {
  publishPlatformMeta();

  if (isNative()) {
    pushToDataLayer(
      [
        'consent',
        'update',
        {
          analytics_storage: 'granted',
          functionality_storage: 'granted',
          personalization_storage: 'granted',
          security_storage: 'granted',
        },
      ],
      { event: 'consent_status' },
    );
  }
}

export const pushEventToDataLayer = (
  eventName: string,
  eventParams: Record<string, unknown> = {},
) => {
  pushToDataLayer({
    event: eventName,
    platform: getPlatform(),
    ...eventParams,
  });
};

export const GTMInit = () => {
  const gtmId = process.env.NEXT_PUBLIC_GTM_ID;
  const auth = process.env.NEXT_PUBLIC_GTM_AUTH;
  const preview = process.env.NEXT_PUBLIC_GTM_PREVIEW;
  const isDisabled = !gtmId || process.env.NEXT_PUBLIC_GTM_DISABLED === 'true';

  if (isDisabled) return null;

  return (
    <GoogleTagManager
      gtmId={gtmId!}
      {...(auth && { auth })}
      {...(preview && { preview })}
    />
  );
};
